import { PricingType, StageInput } from "src/services/api/document"
import { GenreType } from "./common"

export interface CompanyPortalProperties {
    companyId: string | null,
    showDiscoverMe: boolean,
    allowedLanguageList: string[],
    defaultLanguageCombinationTranslateAndCreateFrom: string,
    defaultLanguageCombinationTranslateAndCreateTo: string,
    defaultLanguageCombinationFileFrom: string,
    defaultLanguageCombinationFileTo: string,
    genre: GenreType,
    taxonomy: string
}

export const DEFAULT_COMPANY_PORTAL_PROPERTIES : CompanyPortalProperties= { 
  companyId: null,
  showDiscoverMe: true,
  defaultLanguageCombinationFileFrom: "en_gb",
  defaultLanguageCombinationFileTo: "da",
  defaultLanguageCombinationTranslateAndCreateFrom: "en_gb",
  defaultLanguageCombinationTranslateAndCreateTo: "pl",
  allowedLanguageList: ["pl", "en_gb", "da"],
  genre: 'legal',
  taxonomy: "Category:Law"
}

export interface TranslateFileTablet extends Tablet {
  stages: StageInput[]
  pricingType: PricingType
  quoting: boolean
  multiLang: boolean
  generateTcert?: boolean
  pricingRuleId?: string
}

export const isTranslateFileTablet = (tablet: Tablet) => (tablet as TranslateFileTablet)?.stages

export const getPath = (tablet: Tablet) => isTranslateFileTablet(tablet) ? `/document/${tablet.id}` : `/${tablet.name}`

export const outsourcingIcon = '/exfluency/icons/icon-trans-services.svg'
export const editorIcon = '/exfluency/icons/icon-editor.svg'
export const editorPlusIcon = '/exfluency/icons/icon-editor-plus.svg'

export const getIcon = (tablet: Tablet) => {
  if(tablet.name === 'km-chat') return '/exfluency/icons/icon-ASK.svg'
  if(tablet.name === 'km-generator') return '/exfluency/icons/icon-CREATE.svg'
  if(tablet.name === 'text') return '/exfluency/icons/icon-ai-text-trans.svg'
  if(tablet.name === 'instant') return '/exfluency/icons/icon-ai-file-trans.svg'
  if(tablet.name === 'enhance') return editorIcon
  if(tablet.name === 'trustmine') return editorPlusIcon
  if(tablet.name === 'bi') return '/exfluency/portal-icon_bi.svg'
  if(tablet.type === 'OUTSOURCING') return outsourcingIcon
  return ''
}

export type TabletType = "KM" | "INSOURCING" | "OUTSOURCING"

export type TabletStatus = "ACTIVE" | "INACTIVE"

export interface Tablet{
  id: string
  name: string
  title: string
  description?: string
  type: TabletType
  status: TabletStatus
  priorityGroup: number
  tabletOrder: number
}